import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../store';
import {
    IonPage, IonButton, IonButtons, IonContent, IonBackButton,
    IonHeader, IonIcon, IonTitle, IonToolbar,
} from '@ionic/react';
import { mailOutline, logoGooglePlaystore } from 'ionicons/icons';
import './About.css';



type Props = ReturnType<typeof mapStateToProps>

type State = {
    showPopover: boolean,
    showPopoverEvent: null | MouseEvent
}

class ContactUs extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            showPopover: false,
            showPopoverEvent: null
        };
    }

    componentDidMount() {
        try {
            let adsbygoogle;
            // @ts-ignore
            (adsbygoogle = window.adsbygoogle || []).push({});
          } catch (e) {}
    }
    render() {
        return (
            <IonPage>
                <IonHeader>
                    <IonToolbar color="primary">
                        <IonButtons slot="start">
                            <IonBackButton defaultHref="profile" />
                        </IonButtons>
                        <IonTitle>Contact Us</IonTitle>
                    </IonToolbar>
                </IonHeader>

                <IonContent>
                    <div className="ion-padding about-info">

                        <p>
                            Any feedback, comments, or feature requests are welcome. <br />
                            We are in the process of creating our mobile web app and iOS version. <br />
                        </p>
                        <IonIcon icon={mailOutline} /> <a href="mailto:kennrll16@gmail.com">Send email</a>
                        <p>
                          Help us by donating or rating us on the google play store. <br />
                        </p>
                        <IonIcon icon={logoGooglePlaystore} /> <a href="https://play.google.com/store/apps/details?id=com.national.parks.passport">National Parks</a>
                    </div>
                    <ins className="adsbygoogle"
                    style={{display:'block'}}
                    data-ad-client="ca-pub-2796376641761374"
                    data-ad-slot="1578893839"
                    data-ad-format="auto"
                    data-full-width-responsive="true"></ins>
                </IonContent>
            </IonPage>
        );
    }
}

const mapStateToProps = (state: RootState) => ({});

export default connect(
    mapStateToProps
)(ContactUs);
